module.exports = __webpack_public_path__ + "static/media/right.edb82c17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/images/right.jpg
// module id = 338
// module chunks = 0